import React, { useEffect, useState } from "react";
import UserWrapper from "./VisitProgram.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import VisitProgramServices from "../../api/VisitProgramServices";
import GroupServices from "../../api/GroupServices";
import VisitProgramForm from "../../components/visitProgram/visitProgramForm";
import EncryptDecrypt from "../../api/EncryptDecrypt";

const VisitProgramEdit = props => {
  const [editedData, setEditedData] = useState(undefined);
  const [insuranceList, setInsuranceList] = useState([]);
  const hasParam = props.match.params.id;
  useEffect(() => {
    if (hasParam) {
      const params = {
        id: hasParam
      };
      VisitProgramServices.view(params).then(res => {
        let data = EncryptDecrypt.decrypt(res.data);
        setEditedData(data.data);
      });
    }
    GroupServices.insuranceList().then(res => {
      let data = EncryptDecrypt.decrypt(res.data);
      setInsuranceList(data.data);
    });
  }, []);

  const submitFormHandler = (data, action) => {
    setTimeout(() => {
      props.history.push("/visit-program");
    }, 2000);
  };

  return (
    <UserWrapper {...props}>
      <div className="pos-relative">
        <PageTitle
          props={props}
          title="sidebar.visit_program"
          className="plr-15"
          breadCrumb={[
            {
              name: "sidebar.dashboard",
              url: "/dashboard"
            },
            {
              name: "sidebar.visit_program",
              url: "/visit-program"
            },
            {
              name: hasParam ? "action.edit" : "action.add"
            }
          ]}
        />
        <div
          className="back-icon fs-15 demi-bold-text cursor-pointer"
          onClick={() => props.history.push("/visit-program")}
        >
          <i className="fas fa-step-backward"></i> Back
        </div>
      </div>

      <div className="plr-15">
        <div className="roe-card-style mtb-15">
          <div className="roe-card-header module-header">
            <div className="flex-1 fs-16 demi-bold-text">
              <span className="hash"># </span> {hasParam ? "Edit" : "Add"} Visit
              Program
            </div>
          </div>
          <div className="roe-card-body">
            <VisitProgramForm
              insuranceList={insuranceList}
              onSubmit={submitFormHandler}
              editedData={editedData}
              action={hasParam ? "edit" : "add"}
              {...props}
            />
          </div>
        </div>
      </div>
    </UserWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    authData: {
      token: state.auth.token,
      isLogin: state.auth.isLogin,
      profileImage: state.auth.profile_image,
      adminRoleId: state.auth.admin_role_id,
      adminRole: state.auth.admin_role,
      full_name: state.auth.first_name + " " + state.auth.last_name,
      adminId: state.auth.id,
      service_id: state.auth.service_id
    }
  };
};

export default connect(mapStateToProps, null)(VisitProgramEdit);
